/**
 * Skip link — allows keyboard users to jump directly to main content,
 * bypassing the navigation sidebar. Visible only when focused via Tab.
 */
export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="fixed left-[272px] top-4 z-[100] -translate-y-full opacity-0 pointer-events-none rounded-lg bg-[#00926f] px-4 py-2 text-sm font-medium text-white shadow-lg transition-transform focus:translate-y-0 focus:opacity-100 focus:pointer-events-auto focus:outline-none focus:ring-2 focus:ring-[#00c296] focus:ring-offset-2"
    >
      Saltar al contenido principal
    </a>
  )
}
